// extracted by mini-css-extract-plugin
export default {"base":"DashboardHeader_base__Jdi7I","titlePanel":"DashboardHeader_titlePanel__P9jP3"};